<template>
    <div>
        <v-alert border="left" elevation="2" transition="slide-y-transition" type="error" v-model="error.fetching">
            <div>Une erreur est survenue. Si le problème persiste, contactez le <a
                    href="https://support.yodaforex.com">support Yodaforex</a></div>
            <v-row align="center" class="mt-2" no-gutters>
                <v-spacer></v-spacer>
                <v-col class="shrink">
                    <v-btn @click="fetch" text>Réessayer</v-btn>
                </v-col>
            </v-row>
        </v-alert>
        <v-snackbar color="error" v-model="error.submitting">Une erreur est survenue pendant la sauvegarde</v-snackbar>
        <v-snackbar color="success" v-model="alertSuccess" top :timeout="2000">Modifications enregistrées <v-icon dark>mdi-check-circle</v-icon></v-snackbar>
        <v-container>
            <h3 class="ma-4">Gestion des permissions</h3>
            <v-card :loading="isLoading || isSubmitting">
                <v-skeleton-loader class="pa-4" type="list-item,divider,list-item,divider,list-item,divider,list-item" v-if="isLoading"/>
                <v-expansion-panels accordion>
                    <v-expansion-panel :key="b.trigram" v-for="b in branches">
                        <v-expansion-panel-header>
                          {{b.name}}
                          <span class="caption ml-md-12 ml-4">
                            <span v-if="b.allBranches">Accès illimité</span>
                            <span v-else-if="b.grantedTrigrams.length === 0">Aucun accès</span>
                            <span v-else>Accès à <span class="font-weight-bold">{{b.grantedTrigrams.length}}</span>/{{allBranchesExcept(b).length}} <span v-if="!b.isPilot">des autres</span> agences</span>
                          </span>
                          <div class="text-end">
                            <v-chip color="info" v-if="b.isPilot" outlined><v-icon>mdi-eye</v-icon><span class="hidden-sm-and-down ml-2">Licence pilote</span></v-chip>
                            <v-chip class="ml-1" color="warning" v-if="editedBranchUuidList.indexOf(b.uuid) >= 0"><v-icon>mdi-pencil</v-icon><span class="hidden-sm-and-down ml-1">Non sauvegardé</span></v-chip>
                          </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-container>
                              <span v-if="b.isPilot">Cette <span class="blue--text font-weight-bold">license pilote</span></span><span v-else>En plus de ses propres données, cette agence</span> peut accéder aux données des agences suivantes :
                                <v-form @submit.prevent="submitForm(b)">
                                    <v-checkbox v-model="b.allBranches" label="Toutes les agences, déjà existantes et futures" hide-details :value="true"/>
                                  <div v-if="!b.allBranches">

                                    <v-checkbox :disabled="isSubmitting || b.allBranches === true" :key="bc.trigram"
                                                :label="bc.name" :value="bc.trigram"
                                                hide-details v-for="bc in allBranchesExcept(b)"
                                                v-model="b.grantedTrigrams"/>
                                    <span class="caption">
                                      <a href="#" @click="selectAll(b)">Cocher toutes les agences</a>&nbsp;-&nbsp;<a href="#" @click="deselectAll(b)">Décocher toutes les agences</a></span>
                                  </div>

                                    <v-btn :loading="isSubmitting" block class="mt-4" color="success" type="submit" :disabled="editedBranchUuidList.indexOf(b.uuid) < 0">
                                        Sauvegarder
                                        {{b.name}}
                                    </v-btn>
                                  <v-btn block class="mt-4" color="secondary" @click="cancel(b)" :disabled="editedBranchUuidList.indexOf(b.uuid) < 0">
                                    Annuler les modifications
                                  </v-btn>
                                </v-form>
                            </v-container>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-card>
        </v-container>
    </div>
</template>

<script>

	export default {
		name: "Main",
		components: {},
		data() {
			return {
			  editedBranchUuidList: [],
				branches: [],
				initialBranches: [],
				initialBranchesMap: {},
				isLoading: false,
				isSubmitting: false,
				error: {
					fetching: false,
					submitting: false
				},
				alertSuccess: false
			}
		},
		mounted() {
			this.fetch();
		},
    watch: {
		  branches: {
		    deep: true,
        handler: function (newVal) {
          this.editedBranchUuidList = [];
          for (let i = 0; i < this.branches.length; i++) {
            let editable = JSON.stringify(this.branches[i]);
            let original = JSON.stringify(this.getUneditedBranch(this.branches[i]));
            if (editable !== original) {
              // C'est pas parfait, ça indique des agences comme modifiées si on décoche/re-coche une agence car ça modifie l'ordre des trigrammes dans le tableau
              this.editedBranchUuidList.push(this.branches[i].uuid);
            }
          }
        }
      }
    },
		methods: {
			fetch() {
				this.isLoading = true;
				this.error.fetching = false;
				this.$http.get(this.$config.apiUrl + "/v1/companies/auto/branches")
            .then(r => {
              // On modifie la réponse pour transformer une éventuelle "*" dans la liste en liste vide + allBranches = true
              // Au passage, on fait une copie de l'état initial pour pouvoir rollback
              this.initialBranches = [];
              let branchToProcess = r.data;
              for (let i = 0; i<branchToProcess.length; i++) {
                branchToProcess[i].allBranches = branchToProcess[i].grantedTrigrams.length === 1 && branchToProcess[i].grantedTrigrams[0] === '*'
                if (branchToProcess[i].allBranches) {
                  branchToProcess[i].grantedTrigrams = [];
                }
                let clone = Object.assign({}, branchToProcess[i]);
                this.initialBranches.push(clone);
                this.initialBranchesMap[clone.uuid] = clone;
              }
              this.branches = branchToProcess;
            })
					.catch(e => this.error.fetching = true)
					.finally(() => this.isLoading = false);
			},
			allBranchesExcept(b) {
				return this.branches.filter(br => (br !== b && !br.isPilot));
			},
      selectAll(b){
        b.grantedTrigrams = this.allBranchesExcept(b).map(br=>br.trigram);
      },
      deselectAll(b){
        b.grantedTrigrams = [];
      },
      cancel(b) {
        let uneditedBranch = this.getUneditedBranch(b);
        b.grantedTrigrams = uneditedBranch.grantedTrigrams;
        b.allBranches = uneditedBranch.allBranches;
      },
			submitForm(b) {
				this.isSubmitting = true;
				this.error.submitting = false;
        let grant = b.allBranches === true ? ["*"] : b.grantedTrigrams.filter((a)=> a != '*');
        this.$http.post(this.$config.apiUrl + "/v1/companies/auto/branches/" + b.uuid + "/grantedTrigrams", grant)
					.then(r => {
						this.alertSuccess = true;
						this.fetch();
					})
					.catch(e => this.error.submitting = true)
					.finally(() => this.isSubmitting = false);
			},
      getUneditedBranch(b) {
			  if (b) {
			    return this.initialBranchesMap[b.uuid];
        } else return null;
      }
		}
	}
</script>

<style scoped>

</style>
